const actions = {
    GET_DATA: 'employees/GET_DATA',
    SET_DATA: 'employees/SET_DATA'
};

export default actions